import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsentService {

    constructor(private http: HttpClient) { }

    revokeConsent(ref: string) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(environment.appApiUrl + "revokeConsent/" + ref, null);
    }
    
}
